import { Platform, StyleSheet } from "react-native";
import { webFont } from "../../API/API";

export const createExpandedImageSliderStyles = (scaleAll: number) =>
  StyleSheet.create({
    backdropRoot: {
      zIndex: 9999,
      backgroundColor: 'rgba(0,0,0,0.8)',
    },
    contentWrapper: {
      width: '100%',
      paddingHorizontal: 16 * scaleAll,
      paddingTop: Platform.select({
        web: 24 * scaleAll,
        default: 16 * scaleAll,
      }),
      paddingBottom: 24 * scaleAll,
    },
    topBar: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 12 * scaleAll,
    },
    topBarLeft: {
      flex: 1,
      paddingRight: 8 * scaleAll,
    },
    topBarRight: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12 * scaleAll,
    },
    titleText: {
      fontFamily: webFont('Inter'),
      color: 'white',
      fontSize: 16 * scaleAll,
      fontWeight: '600',
    },
    counterText: {
      fontFamily: webFont('Inter'),
      color: 'rgba(255,255,255,0.8)',
      fontSize: 14 * scaleAll,
    },
    topBarIconWrap: {
      width: 34 * scaleAll,
      height: 34 * scaleAll,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.2)',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255,0.08)',
    },
    carouselWrapper: {
      alignSelf: 'center',
      width: '100%',
      alignItems: 'center',
    },
    carouselInner: {
      alignSelf: 'center',
      maxWidth: 1200,
    },
    carousel: {
      alignSelf: 'center',
    },
    slideInner: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    emptySlide: {
      flex: 1,
      backgroundColor: 'black',
    },
    arrowButton: {
      width: 40 * scaleAll,
      height: 40 * scaleAll,
      borderRadius: 999,
      backgroundColor: 'rgba(0,0,0,0.5)',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: 1,
      borderColor: 'rgba(255,255,255,0.3)',
    },
    arrowLeftWrapper: {
      position: 'absolute',
      top: '50%',
      transform: [{ translateY: -20 * scaleAll }],
    },
    arrowRightWrapper: {
      position: 'absolute',
      top: '50%',
      transform: [{ translateY: -20 * scaleAll }],
    },
    paginationWrapper: {
      marginTop: 12 * scaleAll,
      alignItems: 'center',
      justifyContent: 'center',
    },
    paginationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6 * scaleAll,
    },
    dotStyle: {
      width: 8 * scaleAll,
      height: 8 * scaleAll,
      borderRadius: 999,
      backgroundColor: 'rgba(255,255,255,0.2)',
    },
    activeDotStyle: {
      width: 8 * scaleAll,
      height: 8 * scaleAll,
      borderRadius: 999,
      backgroundColor: 'white',
    },
    hintText: {
      marginTop: 8 * scaleAll,
      textAlign: 'center',
      fontFamily: webFont('Inter'),
      fontSize: 12 * scaleAll,
      color: 'rgba(255,255,255,0.5)',
    },
  });
